<template>
  <vft-qrcode
    class="magic-ui-qr-code"
    :style="config.style"
    :url="_url"
  />
</template>

<script>
import Qrcode from '@tencent/vft-ui/src/Qrcode';
import { request } from '@/ui';
import renderView from '@/ui/src/mixins/renderView';

export default {
  name: 'MagicUiQrCode',

  components: {
    'vft-qrcode': Qrcode,
  },

  mixins: [renderView],

  inject: {
    app: {
      default: {},
    },
  },

  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },

    model: {
      type: [Object, Array],
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      shortUrl: typeof this.config.url === 'string' ? this.config.url : '',
    };
  },

  computed: {
    _url() {
      if (this.config.params) {
        const params = [];
        Object.entries(this.config.params).forEach(([key, value]) => {
          params.push(`${key}=${value}`);
        });
        return `${this.shortUrl}?${params.join('&')}`;
      }
      return this.shortUrl;
    },
  },

  watch: {
    'config.url': {
      async handler(url) {
        if (this.config.needShortUrl) {
          this.shortUrl = await this.getShortUrl(url);
        } else {
          this.shortUrl = url;
        }
      },
    },
  },

  async created() {
    const { config } = this;

    let { url } = config;

    if (typeof config.url === 'function') {
      url = await config.url.bind(this)(this, {
        model: this.model,
      });
    }

    if (config.needShortUrl) {
      this.shortUrl = await this.getShortUrl(url);
    } else {
      this.shortUrl = url;
    }
  },

  methods: {
    async getShortUrl(url) {
      try {
        const suRes = await request({
          url: '//vip.video.qq.com/fcgi-bin/comm_cgi',
          data: {
            name: 'short_url',
            url,
            need_short_url: 1,
            need_qrcode: 0,
          },
        });

        if (suRes.ret === 0) {
          return suRes.short_url;
        }
        return url;
      } catch (e) {
        return url || window.location.href;
      }
    },
  },
};
</script>

